import { render, staticRenderFns } from "./ProductSearchAdmin.vue?vue&type=template&id=6ddae936&scoped=true"
import script from "./ProductSearchAdmin.vue?vue&type=script&lang=js"
export * from "./ProductSearchAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchAdmin.vue?vue&type=style&index=0&id=6ddae936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddae936",
  null
  
)

export default component.exports